import { decodeJWT } from '@/shared/lib/auth';

export const getCurrentSessionJti = (
    accessToken?: string | null,
): string | undefined => {
    if (!accessToken) {
        return undefined;
    }

    const payload = decodeJWT(accessToken);

    if (!payload || typeof payload['session_jti'] !== 'string') {
        return undefined;
    }

    return payload['session_jti'];
};
